import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { ListItemBaseLi, ListItemBaseInnerWrapper } from './ListItemBase.js';

const ListItem = (_a) => {
    var { children, spaceAfter, prefixIcon, suffixIcon, className, onClick } = _a, rest = __rest(_a, ["children", "spaceAfter", "prefixIcon", "suffixIcon", "className", "onClick"]);
    return (React.createElement(ListItemBaseLi, Object.assign({ spaceAfter: spaceAfter, className: className, onClick: onClick }, rest),
        React.createElement(ListItemBaseInnerWrapper, { prefixIcon: prefixIcon, suffixIcon: suffixIcon }, children)));
};

export { ListItem };
//# sourceMappingURL=ListItem.js.map
